module.exports = __webpack_public_path__ + "static/media/onlineShift.cd2ff494.svg";